import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { SendConnectionLinkMutationVariables } from "../../types";

export const SEND_CONNECTION_LINK = gql`
  mutation sendConnectionLink($input: SendConnectionLinkInput!) {
    sendConnectionLink(input: $input) {
      success
    }
  }
`;

export type SendConnectionLinkData = { sendConnectionLink: { success: boolean } };

export default (
  options?: MutationHookOptions<SendConnectionLinkData, SendConnectionLinkMutationVariables>
) => {
  return useMutation<SendConnectionLinkData, SendConnectionLinkMutationVariables>(
    SEND_CONNECTION_LINK,
    options
  );
};
